/**
 * Nuo Networks - Newegg Theme Interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Countdown Timer for Deals (Shell Shocker)
  const timerHours = document.getElementById('ne-deal-hours');
  const timerMinutes = document.getElementById('ne-deal-mins');
  const timerSeconds = document.getElementById('ne-deal-secs');

  if (timerHours && timerMinutes && timerSeconds) {
    let totalSeconds = 14 * 3600 + 42 * 60 + 19; // 14h 42m 19s
    setInterval(() => {
      if (totalSeconds <= 0) {
        totalSeconds = 24 * 3600;
      }
      totalSeconds--;
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      timerHours.textContent = String(h).padStart(2, '0');
      timerMinutes.textContent = String(m).padStart(2, '0');
      timerSeconds.textContent = String(s).padStart(2, '0');
    }, 1000);
  }

  // 2. Quick Search Tag Fill
  const quickTags = document.querySelectorAll('.ne-quick-tag');
  const searchInput = document.querySelector('.ne-search-input');
  const searchForm = document.querySelector('.ne-search-form');

  if (quickTags.length && searchInput) {
    quickTags.forEach(tag => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        const term = tag.getAttribute('data-search') || tag.textContent.trim();
        searchInput.value = term;
        if (searchForm) {
          searchForm.submit();
        }
      });
    });
  }

  // 3. Category Filter Tabs for Shell Shocker (EPCOM Top Picks)
  const dealTabs = document.querySelectorAll('.ne-deals-tab');
  const dealCards = document.querySelectorAll('.ne-product-card[data-category]');

  if (dealTabs.length && dealCards.length) {
    dealTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const targetCategory = tab.getAttribute('data-tab');

        // Update active tab styling
        dealTabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        // Filter cards smoothly
        dealCards.forEach(card => {
          const cardCat = card.getAttribute('data-category');
          if (targetCategory === 'all' || cardCat === targetCategory) {
            card.classList.remove('ne-card-hidden');
            card.style.opacity = '0';
            card.style.transform = 'scale(0.98)';
            setTimeout(() => {
              card.style.opacity = '1';
              card.style.transform = 'scale(1)';
            }, 10);
          } else {
            card.classList.add('ne-card-hidden');
          }
        });
      });
    });
  }

  // 3.1 SKU Code Copy to Clipboard
  const skuButtons = document.querySelectorAll('.ne-sku-copy-btn');
  skuButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const sku = btn.getAttribute('data-sku');
      if (!sku) return;
      try {
        await navigator.clipboard.writeText(sku);
        const originalTitle = btn.getAttribute('title') || 'Copy SKU';
        btn.setAttribute('title', 'Copied!');
        btn.style.color = '#16a34a';
        setTimeout(() => {
          btn.setAttribute('title', originalTitle);
          btn.style.color = '';
        }, 2000);
      } catch (err) {
        console.warn('Clipboard write error:', err);
      }
    });
  });

  // 3.2 Quick Add to Cart via Shopify Ajax Cart API
  const addButtons = document.querySelectorAll('.ne-card-btn');
  addButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      let variantId = btn.getAttribute('data-variant-id');
      const originalHtml = btn.innerHTML;

      btn.innerHTML = '<svg class="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/></svg> <span>Adding...</span>';
      btn.classList.add('loading');
      btn.disabled = true;

      try {
        // If variantId is not preset, resolve from product JSON
        if (!variantId && handle) {
          const res = await fetch(`/products/${handle}.js`);
          if (res.ok) {
            const product = await res.json();
            const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
            variantId = firstAvailable?.id;
          }
        }

        if (variantId) {
          const cartRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });

          if (cartRes.ok) {
            btn.classList.remove('loading');
            btn.classList.add('added');
            btn.innerHTML = '<span>✓ Added to Cart!</span>';

            // Update cart counter badges across page
            const cartCountEls = document.querySelectorAll('.ne-cart-badge, [data-cart-count]');
            cartCountEls.forEach(el => {
              const current = parseInt(el.textContent.trim() || '0', 10);
              el.textContent = current + 1;
            });

            // Trigger theme cart drawer / notification if supported
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

            // Smoothly open Cart Drawer
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
                .then(r => r.text())
                .then(html => {
                  var parsed = new DOMParser().parseFromString(html, 'text/html');
                  var newDrawer = parsed.querySelector('#CartDrawer');
                  var currentDrawer = document.querySelector('#CartDrawer');
                  if (newDrawer && currentDrawer) {
                    currentDrawer.innerHTML = newDrawer.innerHTML;
                  }
                  drawer.classList.remove('is-empty');
                  var inner = drawer.querySelector('.drawer__inner');
                  if (inner) inner.classList.remove('is-empty');
                  var items = drawer.querySelector('cart-drawer-items');
                  if (items) items.classList.remove('is-empty');

                  if (typeof drawer.open === 'function') {
                    drawer.open();
                  }
                })
                .catch(() => {
                  drawer.classList.remove('is-empty');
                  if (typeof drawer.open === 'function') drawer.open();
                });
            }
            // Handle error or redirection
            const errData = await cartRes.json();
            console.warn('Shopify Cart Add response:', errData);
            if (handle) {
              window.location.href = `/products/${handle}`;
              return;
            }
            btn.innerHTML = '<span>View Product</span>';
          }
        } else if (handle) {
          window.location.href = `/products/${handle}`;
          return;
        }
      } catch (err) {
        console.warn('Cart interaction error:', err);
        if (handle) {
          window.location.href = `/products/${handle}`;
          return;
        }
        btn.innerHTML = '<span>View Product</span>';
      }

      setTimeout(() => {
        btn.innerHTML = originalHtml;
        btn.disabled = false;
        btn.classList.remove('loading', 'added');
      }, 3000);
    });
  });

  // 4. Interactive Mega Menu Dropdown (All Categories & Products)
  const megaMenu = document.getElementById('ne-mega-menu');
  const catBtn = document.getElementById('ne-all-categories-btn');
  const megaBackdrop = document.getElementById('ne-mega-backdrop');
  const prodLink = document.getElementById('ne-products-mega-link');

  if (megaMenu && catBtn) {
    let closeTimer = null;

    const openMega = () => {
      clearTimeout(closeTimer);
      megaMenu.classList.add('active');
      catBtn.classList.add('active');
      catBtn.setAttribute('aria-expanded', 'true');
      if (megaBackdrop) megaBackdrop.classList.add('active');
      if (prodLink) prodLink.classList.add('active');
    };

    const closeMega = () => {
      megaMenu.classList.remove('active');
      catBtn.classList.remove('active');
      catBtn.setAttribute('aria-expanded', 'false');
      if (megaBackdrop) megaBackdrop.classList.remove('active');
      if (prodLink) prodLink.classList.remove('active');
    };

    const scheduleClose = () => {
      closeTimer = setTimeout(closeMega, 220);
    };

    // Hover triggers for All Categories button and panel
    catBtn.addEventListener('mouseenter', openMega);
    catBtn.addEventListener('mouseleave', scheduleClose);
    megaMenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    megaMenu.addEventListener('mouseleave', scheduleClose);

    // Click toggle
    catBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (megaMenu.classList.contains('active')) {
        closeMega();
      } else {
        openMega();
      }
    });

    if (prodLink) {
      prodLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (megaMenu.classList.contains('active')) {
          closeMega();
        } else {
          openMega();
        }
      });
    }

    if (megaBackdrop) {
      megaBackdrop.addEventListener('click', closeMega);
    }

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!megaMenu.contains(e.target) && !catBtn.contains(e.target) && !prodLink?.contains(e.target)) {
        closeMega();
      }
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && megaMenu.classList.contains('active')) {
        closeMega();
      }
    });
  }

  // 5. Shell Shocker Deals Smooth Scroll & Highlight Pulse
  const dealsTabBtn = document.getElementById('ne-deals-tab-btn') || document.querySelector('a[href="#deals"]');
  if (dealsTabBtn) {
    dealsTabBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const dealsSection = document.getElementById('deals') || document.querySelector('.ne-deals-section');
      if (dealsSection) {
        dealsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const sectionCard = dealsSection.querySelector('.ne-deals-section') || dealsSection;
        sectionCard.classList.remove('ne-deals-highlight');
        void sectionCard.offsetWidth; // Force reflow
        sectionCard.classList.add('ne-deals-highlight');
        setTimeout(() => {
          sectionCard.classList.remove('ne-deals-highlight');
        }, 2800);
      }
    });
  }

  // 6. Interactive Network & B2B System Builder Modal Engine
  const builderModal = document.getElementById('ne-builder-modal');
  const openBuilderBtns = document.querySelectorAll('#ne-open-builder-btn, .ne-builder-nav-btn, .ne-builder-trigger');
  const closeBuilderBtn = document.getElementById('ne-builder-close-btn');
  const builderBackdrop = document.getElementById('ne-builder-backdrop');
  const bomListContainer = document.getElementById('ne-builder-bom-list');
  const builderWaBtn = document.getElementById('ne-builder-wa-btn');
  const builderSearchBtn = document.getElementById('ne-builder-search-btn');

  if (builderModal) {
    const openBuilder = (e) => {
      if (e) e.preventDefault();
      builderModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      updateBuilderBOM();
    };

    const closeBuilder = () => {
      builderModal.style.display = 'none';
      document.body.style.overflow = '';
    };

    openBuilderBtns.forEach(b => b.addEventListener('click', openBuilder));
    if (closeBuilderBtn) closeBuilderBtn.addEventListener('click', closeBuilder);
    if (builderBackdrop) builderBackdrop.addEventListener('click', closeBuilder);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && builderModal.style.display === 'flex') {
        closeBuilder();
      }
    });

    // Pill selection toggles
    const pillBtns = builderModal.querySelectorAll('.ne-pill-btn');
    pillBtns.forEach(pill => {
      pill.addEventListener('click', () => {
        pill.classList.toggle('active');
        // Ensure at least one discipline stays active
        const activeCount = builderModal.querySelectorAll('.ne-pill-btn.active').length;
        if (activeCount === 0) {
          pill.classList.add('active');
        }
        updateBuilderBOM();
      });
    });

    // Scale radio triggers
    const scaleRadios = builderModal.querySelectorAll('input[name="project_scale"]');
    scaleRadios.forEach(radio => radio.addEventListener('change', updateBuilderBOM));

    // Redundancy checkboxes triggers
    const checkUps = document.getElementById('check-ups');
    const checkStorage = document.getElementById('check-storage');
    const checkRack = document.getElementById('check-rack');

    [checkUps, checkStorage, checkRack].forEach(chk => {
      if (chk) chk.addEventListener('change', updateBuilderBOM);
    });

    function updateBuilderBOM() {
      if (!bomListContainer) return;

      const activeDisciplines = Array.from(builderModal.querySelectorAll('.ne-pill-btn.active')).map(p => p.getAttribute('data-discipline'));
      const scaleValue = builderModal.querySelector('input[name="project_scale"]:checked')?.value || 'small';
      const hasUps = checkUps?.checked ?? true;
      const hasStorage = checkStorage?.checked ?? true;
      const hasRack = checkRack?.checked ?? true;

      const bomItems = [];
      const searchTerms = [];

      // 1. Switching & Core
      if (activeDisciplines.includes('poe-switching')) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>PoE Switching:</strong> 16-Port Gigabit Managed PoE+ Switch (250W) + 2x SFP');
          searchTerms.push('16-Port PoE Switch');
        } else if (scaleValue === 'medium') {
          bomItems.push('• <strong>PoE Switching:</strong> 24-Port Gigabit Managed PoE+ (370W) + 4x 10G SFP+ Uplinks');
          searchTerms.push('24-Port PoE Switch');
        } else {
          bomItems.push('• <strong>Core & Distribution:</strong> 48-Port PoE+ L3 Core Switch (740W) + 10G Aggregation');
          searchTerms.push('48-Port PoE Switch');
        }
      }

      // 2. Video Surveillance
      if (activeDisciplines.includes('surveillance')) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>Surveillance:</strong> 8-Channel 4K H.265+ PoE NVR + (4-8) 5MP IR IP Dome Cameras');
          searchTerms.push('NVR IP Camera');
        } else if (scaleValue === 'medium') {
          bomItems.push('• <strong>Surveillance:</strong> 16-Channel 4K Ultra HD NVR + (12-16) 8MP WDR Bullet/Dome Cameras');
          searchTerms.push('16 Channel NVR');
        } else {
          bomItems.push('• <strong>Surveillance:</strong> 32/64-Channel Enterprise Rackmount NVR + Speed Dome PTZ Cameras');
          searchTerms.push('32 Channel NVR PTZ');
        }
      }

      // 3. Wi-Fi & Wireless
      if (activeDisciplines.includes('wifi-wireless')) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>Wireless:</strong> (2-4) Dual-Band Wi-Fi 7 Ceiling Mount Access Points');
          searchTerms.push('WiFi 7 Access Point');
        } else if (scaleValue === 'medium') {
          bomItems.push('• <strong>Wireless:</strong> (6-12) Tri-Band Wi-Fi 7 APs + Multi-WAN VPN Security Gateway');
          searchTerms.push('WiFi 7 VPN Router');
        } else {
          bomItems.push('• <strong>Wireless:</strong> High-Density Wi-Fi 7 Campus Array + 60GHz Point-to-Point Backhaul');
          searchTerms.push('60GHz Wireless Bridge');
        }
      }

      // 4. Access Control
      if (activeDisciplines.includes('access-control')) {
        bomItems.push('• <strong>Access Control:</strong> Facial Recognition Biometric Terminals + Electromagnetic Door Locks');
        searchTerms.push('Access Control Biometric');
      }

      // 5. Fiber Backbone
      if (activeDisciplines.includes('fiber')) {
        bomItems.push('• <strong>Optical Backbone:</strong> 10G SFP+ Optical Modules + Armored Single-Mode Fiber Spool');
        searchTerms.push('SFP Fiber Optic');
      }

      // 6. Power Backup
      if (hasUps) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>Power Backup:</strong> 1000VA / 900W Line-Interactive Pure Sine Wave UPS');
        } else {
          bomItems.push('• <strong>Power Backup:</strong> 2000VA - 3000VA Online Double-Conversion Rackmount UPS');
        }
      }

      // 7. Surveillance Storage
      if (hasStorage) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>Storage:</strong> (2x 6TB) WD Purple 24/7 Surveillance Hard Drives');
        } else {
          bomItems.push('• <strong>Storage:</strong> (4x 12TB) Enterprise Surveillance SkyHawk/Purple HDDs in RAID 5');
        }
      }

      // 8. Racks & Cabling
      if (hasRack) {
        if (scaleValue === 'small') {
          bomItems.push('• <strong>Rack & Cabling:</strong> 9U Wall-Mount Network Cabinet + 24-Port Cat6 Patch Panel');
        } else {
          bomItems.push('• <strong>Rack & Cabling:</strong> 24U - 42U 4-Post Server Rack + Horizontal Cable Organizers');
        }
      }

      bomListContainer.innerHTML = bomItems.map(item => `<div class="ne-bom-row">${item}</div>`).join('');

      // Build WhatsApp message
      const disciplinesText = activeDisciplines.join(', ');
      const msg = `Hello Nuo Networks USA!%0A%0AI used the interactive Network Builder on nuo-networks.com for a US project quotation:%0A• Disciplines: ${disciplinesText}%0A• Scope: ${scaleValue.toUpperCase()}%0A• Power/Storage: ${hasUps ? 'Online UPS' : 'Standard'} / ${hasStorage ? 'Surveillance Array' : 'Basic'}%0A%0APlease provide an official B2B distributor quote and delivery timeline.`;
      
      if (builderWaBtn) {
        builderWaBtn.href = `https://api.whatsapp.com/send/?phone=14243553283&text=${encodeURIComponent(msg)}&type=phone_number&app_absent=0`;
      }

      if (builderSearchBtn) {
        builderSearchBtn.onclick = () => {
          const query = searchTerms.slice(0, 2).join(' ') || 'PoE Switch Camera';
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        };
      }
    }
  }

  // 9. Mexico Project Execution Modal Triggers
  const mexicoModal = document.getElementById('nuo-mexico-modal');
  const openMexicoBtnFooter = document.getElementById('open-mexico-modal-btn');
  const openMexicoBtnHeader = document.getElementById('ne-header-mexico-btn');
  const closeMexicoBtn = document.getElementById('close-mexico-modal-btn');

  if (mexicoModal) {
    const openMexicoModal = (e) => {
      if (e) e.preventDefault();
      mexicoModal.style.display = 'flex';
      setTimeout(() => {
        mexicoModal.classList.add('active');
      }, 10);
      document.body.style.overflow = 'hidden';
    };

    const closeMexicoModal = (e) => {
      if (e) e.preventDefault();
      mexicoModal.classList.remove('active');
      setTimeout(() => {
        mexicoModal.style.display = 'none';
        document.body.style.overflow = '';
      }, 250);
    };

    if (openMexicoBtnFooter) openMexicoBtnFooter.addEventListener('click', openMexicoModal);
    if (openMexicoBtnHeader) openMexicoBtnHeader.addEventListener('click', openMexicoModal);
    if (closeMexicoBtn) closeMexicoBtn.addEventListener('click', closeMexicoModal);

    mexicoModal.addEventListener('click', (e) => {
      if (e.target === mexicoModal) closeMexicoModal(e);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mexicoModal.classList.contains('active')) {
        closeMexicoModal(e);
      }
    });
  }
});
